import { render } from "./PicCarousel.vue?vue&type=template&id=1b99fcc4"
import script from "./PicCarousel.vue?vue&type=script&lang=js"
export * from "./PicCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__